/**
 * Returns a string truncated from the left with ellipsis for showing in an html element
 * If the full string can be shown, no ellipsis is added at the beginning
 * @param str String to truncate
 * @param numChars Number of characters that can fit the full width of the html node
 * @param overflowBuffer Buffer against paddings and other other elements present in the node
 */
export function ellipsisLeft(str: string, numChars: number, overflowBuffer: number): string {
    const end = str.length;
    const start = end - numChars + overflowBuffer;
    const valSubstring = str.substring(start, end);
    return `${start > 0 ? "..." : ""}${valSubstring}`;
}
